var cleanUpListener = function cleanUpListener(store, newListener) {
  return function () {
    store.listeners = store.listeners.filter(function (listener) {
      return listener !== newListener;
    });
  };
};

export { cleanUpListener };